module.exports = __webpack_public_path__ + "static/ulutiu-ubtao-siamorphe-tiamat-valkur-DND3_FnP-44ee41701fe6cf9e73e694f64501b769.jpg";